module.exports = __webpack_public_path__ + "img/Group 193.fd11f1f1.svg";